module.exports = __webpack_public_path__ + "21b64cb6cb56dd3161afd1e167b0e425.png";